var items = {
  "block.minecraft.air": "воздyx",
  "block.minecraft.stone": "камен",
  "block.minecraft.granite": "гранит",
  "block.minecraft.polished_granite": "полиран гранит",
  "block.minecraft.diorite": "диорит",
  "block.minecraft.polished_diorite": "полиран диорит",
  "block.minecraft.andesite": "андезит",
  "block.minecraft.polished_andesite": "полиран андезит",
  "block.minecraft.grass_block": "блок од трева",
  "block.minecraft.dirt": "земја",
  "block.minecraft.coarse_dirt": "груба земја",
  "block.minecraft.podzol": "подзол",
  "block.minecraft.crimson_nylium": "црвен пеколцелиум",
  "block.minecraft.warped_nylium": "луд пеколцелиум",
  "block.minecraft.cobblestone": "калдрма",
  "block.minecraft.oak_planks": "даски од даб",
  "block.minecraft.spruce_planks": "даски од смрека",
  "block.minecraft.birch_planks": "даски од бреза",
  "block.minecraft.jungle_planks": "даски од џунглиско дрво",
  "block.minecraft.acacia_planks": "даски од акација",
  "block.minecraft.dark_oak_planks": "даски од темен даб",
  "block.minecraft.crimson_planks": "црвени даски",
  "block.minecraft.warped_planks": "луди билки",
  "block.minecraft.oak_sapling": "фиданка од даб",
  "block.minecraft.spruce_sapling": "фиданка од смрека",
  "block.minecraft.birch_sapling": "фиданка од бреза",
  "block.minecraft.jungle_sapling": "фиданка од џунглиско дрво",
  "block.minecraft.acacia_sapling": "фиданка од акација",
  "block.minecraft.dark_oak_sapling": "фиданка од темен даб",
  "block.minecraft.bedrock": "темел",
  "block.minecraft.sand": "песок",
  "block.minecraft.red_sand": "црвен песок",
  "block.minecraft.gravel": "чакал",
  "block.minecraft.gold_ore": "златна руда",
  "block.minecraft.iron_ore": "железна руда",
  "block.minecraft.coal_ore": "јагленова руда",
  "block.minecraft.nether_gold_ore": "пеколна златна руда",
  "block.minecraft.oak_log": "труп од даб",
  "block.minecraft.spruce_log": "труп од смрека",
  "block.minecraft.birch_log": "труп од бреза",
  "block.minecraft.jungle_log": "труп од џунглиско дрво",
  "block.minecraft.acacia_log": "труп од акација",
  "block.minecraft.dark_oak_log": "труп од темен даб",
  "block.minecraft.crimson_stem": "црвено стебло",
  "block.minecraft.warped_stem": "искривенo стебло",
  "block.minecraft.stripped_oak_log": "соголен труп од даб",
  "block.minecraft.stripped_spruce_log": "соголен труп од смрека",
  "block.minecraft.stripped_birch_log": "соголен труп од бреза",
  "block.minecraft.stripped_jungle_log": "соголен труп од џунглиско дрво",
  "block.minecraft.stripped_acacia_log": "соголен труп од акација",
  "block.minecraft.stripped_dark_oak_log": "соголен труп од темен даб",
  "block.minecraft.stripped_crimson_stem": "истрижано црвено стебло",
  "block.minecraft.stripped_warped_stem": "истрижано лудо стебло",
  "block.minecraft.stripped_oak_wood": "соголен даб",
  "block.minecraft.stripped_spruce_wood": "соголена смрека",
  "block.minecraft.stripped_birch_wood": "соголена бреза",
  "block.minecraft.stripped_jungle_wood": "соголено џунглиско дрво",
  "block.minecraft.stripped_acacia_wood": "соголена акација",
  "block.minecraft.stripped_dark_oak_wood": "соголен темен даб",
  "block.minecraft.stripped_crimson_hyphae": "истрижани црвени хифи",
  "block.minecraft.stripped_warped_hyphae": "истрижани луди хифи",
  "block.minecraft.oak_wood": "даб",
  "block.minecraft.spruce_wood": "смрека",
  "block.minecraft.birch_wood": "бреза",
  "block.minecraft.jungle_wood": "џунглиско дрво",
  "block.minecraft.acacia_wood": "акација",
  "block.minecraft.dark_oak_wood": "темен даб",
  "block.minecraft.crimson_hyphae": "црвени хифи",
  "block.minecraft.warped_hyphae": "луди хифи",
  "block.minecraft.oak_leaves": "лисја од даб",
  "block.minecraft.spruce_leaves": "лисја од смрека",
  "block.minecraft.birch_leaves": "лисја од бреза",
  "block.minecraft.jungle_leaves": "лисја од џунглиско дрво",
  "block.minecraft.acacia_leaves": "лисја од акација",
  "block.minecraft.dark_oak_leaves": "лисја од темен даб",
  "block.minecraft.sponge": "сунѓер",
  "block.minecraft.wet_sponge": "влажен сунѓер",
  "block.minecraft.glass": "стакло",
  "block.minecraft.lapis_ore": "лазурна руда",
  "block.minecraft.lapis_block": "блок од лазура",
  "block.minecraft.dispenser": "раздавач",
  "block.minecraft.sandstone": "песочник",
  "block.minecraft.chiseled_sandstone": "длетуван песочник",
  "block.minecraft.cut_sandstone": "сечен песочник",
  "block.minecraft.note_block": "музички блок",
  "block.minecraft.powered_rail": "погонска пруга",
  "block.minecraft.detector_rail": "детектирачка пруга",
  "block.minecraft.sticky_piston": "леплив клип",
  "block.minecraft.cobweb": "пајажина",
  "block.minecraft.grass": "трева",
  "block.minecraft.fern": "папрат",
  "block.minecraft.dead_bush": "мртва грмушка",
  "block.minecraft.seagrass": "морска трева",
  "block.minecraft.sea_pickle": "морска краставица",
  "block.minecraft.piston": "клип",
  "block.minecraft.white_wool": "бела волна",
  "block.minecraft.orange_wool": "портокалова волна",
  "block.minecraft.magenta_wool": "магента волна",
  "block.minecraft.light_blue_wool": "светлосина волна",
  "block.minecraft.yellow_wool": "жолта волна",
  "block.minecraft.lime_wool": "жолто-зелена волна",
  "block.minecraft.pink_wool": "розова волна",
  "block.minecraft.gray_wool": "сива волна",
  "block.minecraft.light_gray_wool": "светлосива волна",
  "block.minecraft.cyan_wool": "сино-зелена волна",
  "block.minecraft.purple_wool": "виолетова волна",
  "block.minecraft.blue_wool": "сина волна",
  "block.minecraft.brown_wool": "кафеава волна",
  "block.minecraft.green_wool": "зелена волна",
  "block.minecraft.red_wool": "црвена волна",
  "block.minecraft.black_wool": "црна волна",
  "block.minecraft.dandelion": "глуварче",
  "block.minecraft.poppy": "афион",
  "block.minecraft.blue_orchid": "сина орхидеја",
  "block.minecraft.allium": "алиум",
  "block.minecraft.azure_bluet": "лазурен блует",
  "block.minecraft.red_tulip": "црвено лале",
  "block.minecraft.orange_tulip": "портокалово лале",
  "block.minecraft.white_tulip": "бело лале",
  "block.minecraft.pink_tulip": "розово лале",
  "block.minecraft.oxeye_daisy": "маргаритка",
  "block.minecraft.cornflower": "модрика",
  "block.minecraft.lily_of_the_valley": "момина солза",
  "block.minecraft.wither_rose": "видер роза",
  "block.minecraft.brown_mushroom": "кафеава печурка",
  "block.minecraft.red_mushroom": "црвена печурка",
  "block.minecraft.crimson_fungus": "црвен корен",
  "block.minecraft.warped_fungus": "луд корен",
  "block.minecraft.crimson_roots": "црвени корени",
  "block.minecraft.warped_roots": "луди корени",
  "block.minecraft.nether_sprouts": "пеколски клици",
  "block.minecraft.weeping_vines": "тажни гранки",
  "block.minecraft.twisting_vines": "вртени гранки",
  "block.minecraft.sugar_cane": "шеќерна трска",
  "block.minecraft.kelp": "алга",
  "block.minecraft.bamboo": "бамбус",
  "block.minecraft.gold_block": "блок од злато",
  "block.minecraft.iron_block": "блок од железо",
  "block.minecraft.oak_slab": "плоча од даб",
  "block.minecraft.spruce_slab": "плоча од смрека",
  "block.minecraft.birch_slab": "плоча од бреза",
  "block.minecraft.jungle_slab": "плоча од џунглиско дрво",
  "block.minecraft.acacia_slab": "плоча од акација",
  "block.minecraft.dark_oak_slab": "плоча од темен даб",
  "block.minecraft.crimson_slab": "црвена плочка",
  "block.minecraft.warped_slab": "луда плочка",
  "block.minecraft.stone_slab": "камена плоча",
  "block.minecraft.smooth_stone_slab": "мазна камена плоча",
  "block.minecraft.sandstone_slab": "плоча од песочник",
  "block.minecraft.cut_sandstone_slab": "плоча од сечен песочник",
  "block.minecraft.petrified_oak_slab": "скаменета плоча од даб",
  "block.minecraft.cobblestone_slab": "плоча од калдрма",
  "block.minecraft.brick_slab": "циглена плоча",
  "block.minecraft.stone_brick_slab": "плоча од камени цигли",
  "block.minecraft.nether_brick_slab": "плоча од недер цигли",
  "block.minecraft.quartz_slab": "кварцна плоча",
  "block.minecraft.red_sandstone_slab": "плоча од црвен песочник",
  "block.minecraft.cut_red_sandstone_slab": "плоча од сечен црвен песочник",
  "block.minecraft.purpur_slab": "плоча од пурпур",
  "block.minecraft.prismarine_slab": "плоча од призмарин",
  "block.minecraft.prismarine_brick_slab": "плоча од призмарински цигли",
  "block.minecraft.dark_prismarine_slab": "плоча од темен призмарин",
  "block.minecraft.smooth_quartz": "мазна квартц коцка",
  "block.minecraft.smooth_red_sandstone": "мазен црвен песочник",
  "block.minecraft.smooth_sandstone": "мазен песочник",
  "block.minecraft.smooth_stone": "мазен камен",
  "block.minecraft.bricks": "цигли",
  "block.minecraft.tnt": "тнт",
  "block.minecraft.bookshelf": "полица за книги",
  "block.minecraft.mossy_cobblestone": "мовлива калдрма",
  "block.minecraft.obsidian": "обсидијан",
  "block.minecraft.torch": "факел",
  "block.minecraft.end_rod": "енд прачка",
  "block.minecraft.chorus_plant": "хорус растение",
  "block.minecraft.chorus_flower": "хорус цвет",
  "block.minecraft.purpur_block": "блок од пурпур",
  "block.minecraft.purpur_pillar": "столб од пурпур",
  "block.minecraft.purpur_stairs": "скали од пурпур",
  "block.minecraft.spawner": "создавач",
  "block.minecraft.oak_stairs": "скали од даб",
  "block.minecraft.chest": "сандак",
  "block.minecraft.diamond_ore": "дијамантска руда",
  "block.minecraft.diamond_block": "блок од дијамант",
  "block.minecraft.crafting_table": "работна маса",
  "block.minecraft.farmland": "обработлива земја",
  "block.minecraft.furnace": "печка",
  "block.minecraft.ladder": "скала",
  "block.minecraft.rail": "пруга",
  "block.minecraft.cobblestone_stairs": "скали од калдрма",
  "block.minecraft.lever": "рачка",
  "block.minecraft.stone_pressure_plate": "камена притисна плоча",
  "block.minecraft.oak_pressure_plate": "притисна плоча од даб",
  "block.minecraft.spruce_pressure_plate": "притисна плоча од смрека",
  "block.minecraft.birch_pressure_plate": "притисна плоча од бреза",
  "block.minecraft.jungle_pressure_plate": "притисна плоча од џунглиско дрво",
  "block.minecraft.acacia_pressure_plate": "притисна плоча од акација",
  "block.minecraft.dark_oak_pressure_plate": "притисна плоча од темен даб",
  "block.minecraft.crimson_pressure_plate": "црвена притисочна плочка",
  "block.minecraft.warped_pressure_plate": "луда притисочна плочка",
  "block.minecraft.polished_blackstone_pressure_plate": "размазена притисочна плочка од црн камен",
  "block.minecraft.redstone_ore": "редстоун руда",
  "block.minecraft.redstone_torch": "редстоун факел",
  "block.minecraft.snow": "снег",
  "block.minecraft.ice": "мраз",
  "block.minecraft.snow_block": "снежен блок",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "глина",
  "block.minecraft.jukebox": "џубокс",
  "block.minecraft.oak_fence": "ограда од даб",
  "block.minecraft.spruce_fence": "ограда од смрека",
  "block.minecraft.birch_fence": "ограда од бреза",
  "block.minecraft.jungle_fence": "ограда од џунглиско дрво",
  "block.minecraft.acacia_fence": "ограда од акација",
  "block.minecraft.dark_oak_fence": "ограда од темен даб",
  "block.minecraft.crimson_fence": "црвена ограда",
  "block.minecraft.warped_fence": "луда ограда",
  "block.minecraft.pumpkin": "тиква",
  "block.minecraft.carved_pumpkin": "врежана тиква",
  "block.minecraft.netherrack": "недер камен",
  "block.minecraft.soul_sand": "духовен песок",
  "block.minecraft.soul_soil": "душна земја",
  "block.minecraft.basalt": "базалт",
  "block.minecraft.polished_basalt": "измазен базалт",
  "block.minecraft.soul_torch": "душен факел",
  "block.minecraft.glowstone": "светлосен камен",
  "block.minecraft.jack_o_lantern": "тиквен фенер",
  "block.minecraft.oak_trapdoor": "врата-стапица од даб",
  "block.minecraft.spruce_trapdoor": "врата-стапица од смрека",
  "block.minecraft.birch_trapdoor": "врата-стапица од бреза",
  "block.minecraft.jungle_trapdoor": "врата-стапица од џунглиско дрво",
  "block.minecraft.acacia_trapdoor": "врата-стапица од акација",
  "block.minecraft.dark_oak_trapdoor": "врата-стапица од темен даб",
  "block.minecraft.crimson_trapdoor": "црвена подна врата",
  "block.minecraft.warped_trapdoor": "луда подна врата",
  "block.minecraft.infested_stone": "заразен камен",
  "block.minecraft.infested_cobblestone": "заразена калдрма",
  "block.minecraft.infested_stone_bricks": "заразени камени цигли",
  "block.minecraft.infested_mossy_stone_bricks": "заразени мовливи камени цигли",
  "block.minecraft.infested_cracked_stone_bricks": "заразени напукнати камени цигли",
  "block.minecraft.infested_chiseled_stone_bricks": "заразени длетувани камени цигли",
  "block.minecraft.stone_bricks": "камени цигли",
  "block.minecraft.mossy_stone_bricks": "мовливи камени цигли",
  "block.minecraft.cracked_stone_bricks": "напукнати камени цигли",
  "block.minecraft.chiseled_stone_bricks": "длетувани камени цигли",
  "block.minecraft.brown_mushroom_block": "блок од кафеава печурка",
  "block.minecraft.red_mushroom_block": "блок од црвена печурка",
  "block.minecraft.mushroom_stem": "стебло од печурка",
  "block.minecraft.iron_bars": "железни решетки",
  "block.minecraft.chain": "верижен",
  "block.minecraft.glass_pane": "стаклена рамка",
  "block.minecraft.melon": "лубеница",
  "block.minecraft.vine": "лози",
  "block.minecraft.oak_fence_gate": "врата за ограда од даб",
  "block.minecraft.spruce_fence_gate": "врата за ограда од смрека",
  "block.minecraft.birch_fence_gate": "врата за ограда од бреза",
  "block.minecraft.jungle_fence_gate": "врата за ограда од џунглиско дрво",
  "block.minecraft.acacia_fence_gate": "врата за ограда од акација",
  "block.minecraft.dark_oak_fence_gate": "врата за ограда од темен даб",
  "block.minecraft.crimson_fence_gate": "црвена порта",
  "block.minecraft.warped_fence_gate": "луда порта",
  "block.minecraft.brick_stairs": "скали од цигли",
  "block.minecraft.stone_brick_stairs": "скали од камени цигли",
  "block.minecraft.mycelium": "мицелиум",
  "block.minecraft.lily_pad": "воден лилјан",
  "block.minecraft.nether_bricks": "недер цигли",
  "block.minecraft.cracked_nether_bricks": "пукнати пеколски цигли",
  "block.minecraft.chiseled_nether_bricks": "изработени пеколски цигли",
  "block.minecraft.nether_brick_fence": "ограда од недер цигли",
  "block.minecraft.nether_brick_stairs": "скали од недер цигли",
  "block.minecraft.enchanting_table": "маса за маѓепсување",
  "block.minecraft.end_portal_frame": "рамка за енд портал",
  "block.minecraft.end_stone": "енд камен",
  "block.minecraft.end_stone_bricks": "цигли од енд камен",
  "block.minecraft.dragon_egg": "змејско јајце",
  "block.minecraft.redstone_lamp": "ламба",
  "block.minecraft.sandstone_stairs": "скали од песочник",
  "block.minecraft.emerald_ore": "смарагдна руда",
  "block.minecraft.ender_chest": "ендер сандак",
  "block.minecraft.tripwire_hook": "кука за нагазна жица",
  "block.minecraft.emerald_block": "блок од смарагд",
  "block.minecraft.spruce_stairs": "скали од смрека",
  "block.minecraft.birch_stairs": "скали од бреза",
  "block.minecraft.jungle_stairs": "скали од џунглиско дрво",
  "block.minecraft.crimson_stairs": "црвени скали",
  "block.minecraft.warped_stairs": "луди скали",
  "block.minecraft.command_block": "команден блок",
  "block.minecraft.beacon": "светилник",
  "block.minecraft.cobblestone_wall": "ѕид од калдрма",
  "block.minecraft.mossy_cobblestone_wall": "ѕид од мовлива калдрма",
  "block.minecraft.brick_wall": "ѕид од цигли",
  "block.minecraft.prismarine_wall": "ѕид од призмарин",
  "block.minecraft.red_sandstone_wall": "ѕид од црвен песочник",
  "block.minecraft.mossy_stone_brick_wall": "ѕид од мовливи камени цигли",
  "block.minecraft.granite_wall": "гранитен ѕид",
  "block.minecraft.stone_brick_wall": "ѕид од камени цигли",
  "block.minecraft.nether_brick_wall": "ѕид од недер цигли",
  "block.minecraft.andesite_wall": "андезитен ѕид",
  "block.minecraft.red_nether_brick_wall": "ѕид од црвени недер цигли",
  "block.minecraft.sandstone_wall": "ѕид од песочник",
  "block.minecraft.end_stone_brick_wall": "ѕид од енд камени цигли",
  "block.minecraft.diorite_wall": "диоритен ѕид",
  "block.minecraft.blackstone_wall": "sид од црн камен",
  "block.minecraft.polished_blackstone_wall": "sид од размазен црн камен",
  "block.minecraft.polished_blackstone_brick_wall": "sид од размазен црн камен",
  "block.minecraft.stone_button": "копче од камен",
  "block.minecraft.oak_button": "копче од даб",
  "block.minecraft.spruce_button": "копче од смрека",
  "block.minecraft.birch_button": "копче од бреза",
  "block.minecraft.jungle_button": "копче од џунглиско дрво",
  "block.minecraft.acacia_button": "копче од акација",
  "block.minecraft.dark_oak_button": "копче од темен даб",
  "block.minecraft.crimson_button": "црвено копче",
  "block.minecraft.warped_button": "лудо копче",
  "block.minecraft.polished_blackstone_button": "размазено копче од црн камен",
  "block.minecraft.anvil": "наковална",
  "block.minecraft.chipped_anvil": "поткршена наковална",
  "block.minecraft.damaged_anvil": "оштетена наковална",
  "block.minecraft.trapped_chest": "сандак-стапица",
  "block.minecraft.light_weighted_pressure_plate": "леснотежинска притисна плоча",
  "block.minecraft.heavy_weighted_pressure_plate": "тешкотежинска притисна плоча",
  "block.minecraft.daylight_detector": "сензор за дневна светлина",
  "block.minecraft.redstone_block": "блок од редстоун",
  "block.minecraft.nether_quartz_ore": "недер-кварцна руда",
  "block.minecraft.hopper": "собирач",
  "block.minecraft.chiseled_quartz_block": "коцка од длетуван кварц",
  "block.minecraft.quartz_block": "коцка од кварц",
  "block.minecraft.quartz_bricks": "цигли од квартц",
  "block.minecraft.quartz_pillar": "кварцен столб",
  "block.minecraft.quartz_stairs": "скали од кварц",
  "block.minecraft.activator_rail": "активаторска пруга",
  "block.minecraft.dropper": "исфрлувач",
  "block.minecraft.white_terracotta": "бела теракота",
  "block.minecraft.orange_terracotta": "портокалова теракота",
  "block.minecraft.magenta_terracotta": "магента теракота",
  "block.minecraft.light_blue_terracotta": "светлосина теракота",
  "block.minecraft.yellow_terracotta": "жолта теракота",
  "block.minecraft.lime_terracotta": "жолто-зелена теракота",
  "block.minecraft.pink_terracotta": "розова теракота",
  "block.minecraft.gray_terracotta": "сива теракота",
  "block.minecraft.light_gray_terracotta": "светлосива теракота",
  "block.minecraft.cyan_terracotta": "сино-зелена теракота",
  "block.minecraft.purple_terracotta": "виолетова теракота",
  "block.minecraft.blue_terracotta": "сина теракота",
  "block.minecraft.brown_terracotta": "кафеава теракота",
  "block.minecraft.green_terracotta": "зелена теракота",
  "block.minecraft.red_terracotta": "црвена теракота",
  "block.minecraft.black_terracotta": "црна теракота",
  "block.minecraft.barrier": "бариера",
  "block.minecraft.iron_trapdoor": "железна врата-стапица",
  "block.minecraft.hay_block": "бала сено",
  "block.minecraft.white_carpet": "бел тепих",
  "block.minecraft.orange_carpet": "портокалов тепих",
  "block.minecraft.magenta_carpet": "магента тепих",
  "block.minecraft.light_blue_carpet": "светлосин тепих",
  "block.minecraft.yellow_carpet": "жолт тепих",
  "block.minecraft.lime_carpet": "жолто-зелен тепих",
  "block.minecraft.pink_carpet": "розов тепих",
  "block.minecraft.gray_carpet": "сив тепих",
  "block.minecraft.light_gray_carpet": "светлосив тепих",
  "block.minecraft.cyan_carpet": "сино-зелен тепих",
  "block.minecraft.purple_carpet": "виолетов тепих",
  "block.minecraft.blue_carpet": "син тепих",
  "block.minecraft.brown_carpet": "кафеав тепих",
  "block.minecraft.green_carpet": "зелен тепих",
  "block.minecraft.red_carpet": "црвен тепих",
  "block.minecraft.black_carpet": "црн тепих",
  "block.minecraft.terracotta": "теракота",
  "block.minecraft.coal_block": "блок од јаглен",
  "block.minecraft.packed_ice": "тврд лед",
  "block.minecraft.acacia_stairs": "скали од акација",
  "block.minecraft.dark_oak_stairs": "скали од темен даб",
  "block.minecraft.slime_block": "коцка од слуз",
  "block.minecraft.grass_path": "тревна патека",
  "block.minecraft.sunflower": "сончоглед",
  "block.minecraft.lilac": "јоргован",
  "block.minecraft.rose_bush": "грмушка со рози",
  "block.minecraft.peony": "божур",
  "block.minecraft.tall_grass": "висока трева",
  "block.minecraft.large_fern": "голем папрат",
  "block.minecraft.white_stained_glass": "бело стакло",
  "block.minecraft.orange_stained_glass": "портокалово стакло",
  "block.minecraft.magenta_stained_glass": "магента стакло",
  "block.minecraft.light_blue_stained_glass": "светлосино стакло",
  "block.minecraft.yellow_stained_glass": "жолто стакло",
  "block.minecraft.lime_stained_glass": "жолто-зелено стакло",
  "block.minecraft.pink_stained_glass": "розово стакло",
  "block.minecraft.gray_stained_glass": "сиво стакло",
  "block.minecraft.light_gray_stained_glass": "светлосиво стакло",
  "block.minecraft.cyan_stained_glass": "сино-зелено стакло",
  "block.minecraft.purple_stained_glass": "виолетово стакло",
  "block.minecraft.blue_stained_glass": "сино стакло",
  "block.minecraft.brown_stained_glass": "кафеаво стакло",
  "block.minecraft.green_stained_glass": "зелено стакло",
  "block.minecraft.red_stained_glass": "црвено стакло",
  "block.minecraft.black_stained_glass": "црно стакло",
  "block.minecraft.white_stained_glass_pane": "бела стаклена рамка",
  "block.minecraft.orange_stained_glass_pane": "портокалова стаклена рамка",
  "block.minecraft.magenta_stained_glass_pane": "магента стаклена рамка",
  "block.minecraft.light_blue_stained_glass_pane": "светлосина стаклена рамка",
  "block.minecraft.yellow_stained_glass_pane": "жолта стаклена рамка",
  "block.minecraft.lime_stained_glass_pane": "жолто-зелена стаклена рамка",
  "block.minecraft.pink_stained_glass_pane": "розова стаклена рамка",
  "block.minecraft.gray_stained_glass_pane": "сива стаклена рамка",
  "block.minecraft.light_gray_stained_glass_pane": "светлосива стаклена рамка",
  "block.minecraft.cyan_stained_glass_pane": "сино-зелена стаклена рамка",
  "block.minecraft.purple_stained_glass_pane": "виолетова стаклена рамка",
  "block.minecraft.blue_stained_glass_pane": "сина стаклена рамка",
  "block.minecraft.brown_stained_glass_pane": "кафеава стаклена рамка",
  "block.minecraft.green_stained_glass_pane": "зелена стаклена рамка",
  "block.minecraft.red_stained_glass_pane": "црвена стаклена рамка",
  "block.minecraft.black_stained_glass_pane": "црна стаклена рамка",
  "block.minecraft.prismarine": "призмарин",
  "block.minecraft.prismarine_bricks": "призмарински цигли",
  "block.minecraft.dark_prismarine": "темен призмарин",
  "block.minecraft.prismarine_stairs": "скали од призмарин",
  "block.minecraft.prismarine_brick_stairs": "скали од призмарински цигли",
  "block.minecraft.dark_prismarine_stairs": "скали од темен призмарин",
  "block.minecraft.sea_lantern": "морски фенер",
  "block.minecraft.red_sandstone": "црвен песочник",
  "block.minecraft.chiseled_red_sandstone": "длетуван црвен песочник",
  "block.minecraft.cut_red_sandstone": "сечен црвен песочник",
  "block.minecraft.red_sandstone_stairs": "скали од црвен песочник",
  "block.minecraft.repeating_command_block": "повторувачки команден блок",
  "block.minecraft.chain_command_block": "верижен команден блок",
  "block.minecraft.magma_block": "блок од магма",
  "block.minecraft.nether_wart_block": "блок од недер растение",
  "block.minecraft.warped_wart_block": "луда бубуљична коцка",
  "block.minecraft.red_nether_bricks": "црвени недер цигли",
  "block.minecraft.bone_block": "блок од коска",
  "block.minecraft.structure_void": "структурна празнина",
  "block.minecraft.observer": "опсерватор",
  "block.minecraft.shulker_box": "шулкер кутија",
  "block.minecraft.white_shulker_box": "бела шулкер кутија",
  "block.minecraft.orange_shulker_box": "портокалова шулкер кутија",
  "block.minecraft.magenta_shulker_box": "магента шулкер кутија",
  "block.minecraft.light_blue_shulker_box": "светлосина шулкер кутија",
  "block.minecraft.yellow_shulker_box": "жолта шулкер кутија",
  "block.minecraft.lime_shulker_box": "жолто-зелена шулкер кутија",
  "block.minecraft.pink_shulker_box": "розова шулкер кутија",
  "block.minecraft.gray_shulker_box": "сива шулкер кутија",
  "block.minecraft.light_gray_shulker_box": "светлосива шулкер кутија",
  "block.minecraft.cyan_shulker_box": "сино-зелена шулкер кутија",
  "block.minecraft.purple_shulker_box": "виолетова шулкер кутија",
  "block.minecraft.blue_shulker_box": "сина шулкер кутија",
  "block.minecraft.brown_shulker_box": "кафеава шулкер кутија",
  "block.minecraft.green_shulker_box": "зелена шулкер кутија",
  "block.minecraft.red_shulker_box": "црвена шулкер кутија",
  "block.minecraft.black_shulker_box": "црна шулкер кутија",
  "block.minecraft.white_glazed_terracotta": "бела глазирана теракота",
  "block.minecraft.orange_glazed_terracotta": "портокалова глазирана теракота",
  "block.minecraft.magenta_glazed_terracotta": "магента глазирана теракота",
  "block.minecraft.light_blue_glazed_terracotta": "светлосина глазирана теракота",
  "block.minecraft.yellow_glazed_terracotta": "жолта глазирана теракота",
  "block.minecraft.lime_glazed_terracotta": "жолто-зелена глазирана теракота",
  "block.minecraft.pink_glazed_terracotta": "розова глазирана теракота",
  "block.minecraft.gray_glazed_terracotta": "сива глазирана теракота",
  "block.minecraft.light_gray_glazed_terracotta": "светлосина глазирана теракота",
  "block.minecraft.cyan_glazed_terracotta": "сино-зелена глазирана теракота",
  "block.minecraft.purple_glazed_terracotta": "виолетова глазирана теракота",
  "block.minecraft.blue_glazed_terracotta": "сина глазирана теракота",
  "block.minecraft.brown_glazed_terracotta": "кафеава глазирана теракота",
  "block.minecraft.green_glazed_terracotta": "зелена глазирана теракота",
  "block.minecraft.red_glazed_terracotta": "црвена глазирана теракота",
  "block.minecraft.black_glazed_terracotta": "црна глазирана теракота",
  "block.minecraft.white_concrete": "бел бетон",
  "block.minecraft.orange_concrete": "портокалов бетон",
  "block.minecraft.magenta_concrete": "магента бетон",
  "block.minecraft.light_blue_concrete": "светлосин бетон",
  "block.minecraft.yellow_concrete": "жолт бетон",
  "block.minecraft.lime_concrete": "жолто-зелен бетон",
  "block.minecraft.pink_concrete": "розов бетон",
  "block.minecraft.gray_concrete": "сив бетон",
  "block.minecraft.light_gray_concrete": "светлосив бетон",
  "block.minecraft.cyan_concrete": "сино-зелен бетон",
  "block.minecraft.purple_concrete": "виолетов бетон",
  "block.minecraft.blue_concrete": "син бетон",
  "block.minecraft.brown_concrete": "кафеав бетон",
  "block.minecraft.green_concrete": "зелен бетон",
  "block.minecraft.red_concrete": "црвен бетон",
  "block.minecraft.black_concrete": "црн бетон",
  "block.minecraft.white_concrete_powder": "бел бетон во прав",
  "block.minecraft.orange_concrete_powder": "портокалов бетон во прав",
  "block.minecraft.magenta_concrete_powder": "магента бетон во прав",
  "block.minecraft.light_blue_concrete_powder": "светлосин бетон во прав",
  "block.minecraft.yellow_concrete_powder": "жолт бетон во прав",
  "block.minecraft.lime_concrete_powder": "жолто-зелен бетон во прав",
  "block.minecraft.pink_concrete_powder": "розов бетон во прав",
  "block.minecraft.gray_concrete_powder": "сив бетон во прав",
  "block.minecraft.light_gray_concrete_powder": "светлосив бетон во прав",
  "block.minecraft.cyan_concrete_powder": "сино-зелен бетон во прав",
  "block.minecraft.purple_concrete_powder": "виолетов бетон во прав",
  "block.minecraft.blue_concrete_powder": "син бетон во прав",
  "block.minecraft.brown_concrete_powder": "кафеав бетон во прав",
  "block.minecraft.green_concrete_powder": "зелен бетон во прав",
  "block.minecraft.red_concrete_powder": "црвен бетон во прав",
  "block.minecraft.black_concrete_powder": "црн бетон во прав",
  "block.minecraft.turtle_egg": "јајце од желка",
  "block.minecraft.dead_tube_coral_block": "мртов цевчест корален блок",
  "block.minecraft.dead_brain_coral_block": "мртов мозочен корален блок",
  "block.minecraft.dead_bubble_coral_block": "мртов меурчест корален блок",
  "block.minecraft.dead_fire_coral_block": "мртов огнен корален блок",
  "block.minecraft.dead_horn_coral_block": "мртов рожен корален блок",
  "block.minecraft.tube_coral_block": "цевчест корален блок",
  "block.minecraft.brain_coral_block": "мозочен корален блок",
  "block.minecraft.bubble_coral_block": "меурчест корален блок",
  "block.minecraft.fire_coral_block": "огнен корален блок",
  "block.minecraft.horn_coral_block": "рожен корален блок",
  "block.minecraft.tube_coral": "цевчест корал",
  "block.minecraft.brain_coral": "мозочен корал",
  "block.minecraft.bubble_coral": "меурчест корал",
  "block.minecraft.fire_coral": "огнен корал",
  "block.minecraft.horn_coral": "рожен корал",
  "block.minecraft.dead_brain_coral": "мртов мозочен корал",
  "block.minecraft.dead_bubble_coral": "мртов меурчест корал",
  "block.minecraft.dead_fire_coral": "мртов огнен корал",
  "block.minecraft.dead_horn_coral": "мртов рожен корал",
  "block.minecraft.dead_tube_coral": "мртов цевчест корал",
  "block.minecraft.tube_coral_fan": "цевчеста корална лепеза",
  "block.minecraft.brain_coral_fan": "мозочна корална лепеза",
  "block.minecraft.bubble_coral_fan": "меурчеста корална лепеза",
  "block.minecraft.fire_coral_fan": "огнена корална лепеза",
  "block.minecraft.horn_coral_fan": "рожна корална лепеза",
  "block.minecraft.dead_tube_coral_fan": "мртва цевчеста корална лепеза",
  "block.minecraft.dead_brain_coral_fan": "мртва мозочна корална лепеза",
  "block.minecraft.dead_bubble_coral_fan": "мртва меурчеста корална лепеза",
  "block.minecraft.dead_fire_coral_fan": "мртва огнена корална лепеза",
  "block.minecraft.dead_horn_coral_fan": "мртва ѕидна рожна корална лепеза",
  "block.minecraft.blue_ice": "син мраз",
  "block.minecraft.conduit": "подводна клетка",
  "block.minecraft.polished_granite_stairs": "полирани гранитни скали",
  "block.minecraft.smooth_red_sandstone_stairs": "мазни скали од црвен песочник",
  "block.minecraft.mossy_stone_brick_stairs": "скали од мовливи камени цигли",
  "block.minecraft.polished_diorite_stairs": "скали од полиран диорит",
  "block.minecraft.mossy_cobblestone_stairs": "скали од мовлива калдрма",
  "block.minecraft.end_stone_brick_stairs": "скали од енд цигли",
  "block.minecraft.stone_stairs": "камени скали",
  "block.minecraft.smooth_sandstone_stairs": "скали од мазен песочник",
  "block.minecraft.smooth_quartz_stairs": "скали од мазен кварц",
  "block.minecraft.granite_stairs": "гранитни скали",
  "block.minecraft.andesite_stairs": "андезитни скали",
  "block.minecraft.red_nether_brick_stairs": "скали од црвени недер цигли",
  "block.minecraft.polished_andesite_stairs": "полирани андезитни скали",
  "block.minecraft.diorite_stairs": "диоритни скали",
  "block.minecraft.polished_granite_slab": "полирана гранитна плоча",
  "block.minecraft.smooth_red_sandstone_slab": "плоча од полиран црвен песочник",
  "block.minecraft.mossy_stone_brick_slab": "плоча од мовливи камени цигли",
  "block.minecraft.polished_diorite_slab": "полирана диоритна плоча",
  "block.minecraft.mossy_cobblestone_slab": "плоча од мовлива калдрма",
  "block.minecraft.end_stone_brick_slab": "плоча од енд камени цигли",
  "block.minecraft.smooth_sandstone_slab": "плоча од мазен песочник",
  "block.minecraft.smooth_quartz_slab": "плоча од мазен кварц",
  "block.minecraft.granite_slab": "гранитна плоча",
  "block.minecraft.andesite_slab": "андезитна плоча",
  "block.minecraft.red_nether_brick_slab": "плоча од црвени недер цигли",
  "block.minecraft.polished_andesite_slab": "полирана андезитна плоча",
  "block.minecraft.diorite_slab": "диоритна плоча",
  "block.minecraft.scaffolding": "скеле",
  "block.minecraft.iron_door": "железна врата",
  "block.minecraft.oak_door": "врата од даб",
  "block.minecraft.spruce_door": "врата од смрека",
  "block.minecraft.birch_door": "врата од бреза",
  "block.minecraft.jungle_door": "врата од џунглиско дрво",
  "block.minecraft.acacia_door": "врата од акација",
  "block.minecraft.dark_oak_door": "врата од темен даб",
  "block.minecraft.crimson_door": "црвена врата",
  "block.minecraft.warped_door": "луда врата",
  "block.minecraft.repeater": "редстоун повторувач",
  "block.minecraft.comparator": "редстоун споредник",
  "block.minecraft.structure_block": "структурен блок",
  "block.minecraft.jigsaw": "сложувалка",
  "item.minecraft.turtle_helmet": "желкина школка□□кога е на главата:□+2 оклоп",
  "item.minecraft.scute": "рожен оклоп",
  "item.minecraft.iron_shovel": "железна лопата□□кога сте во главната рака:□+3.5 штета на напад□-3 брзина на напад",
  "item.minecraft.iron_pickaxe": "железен копач□□кога сте во главната рака:□+3 штета на напад□-2.8 брзина на напад",
  "item.minecraft.iron_axe": "железна секира□□кога сте во главната рака:□+8 штета на напад□-3.1 брзина на напад",
  "item.minecraft.flint_and_steel": "запалка",
  "item.minecraft.apple": "јаболко",
  "item.minecraft.bow": "лак",
  "item.minecraft.arrow": "стрела",
  "item.minecraft.coal": "јаглен",
  "item.minecraft.charcoal": "ќумур",
  "item.minecraft.diamond": "дијамант",
  "item.minecraft.iron_ingot": "железен калап",
  "item.minecraft.gold_ingot": "златен калап",
  "item.minecraft.netherite_ingot": "пеколитски ингот",
  "item.minecraft.netherite_scrap": "парче пеколит",
  "item.minecraft.iron_sword": "железен меч□□кога сте во главната рака:□+5 штета на напад□-2.4 брзина на напад",
  "item.minecraft.wooden_sword": "дрвен меч□□кога сте во главната рака:□+3 штета на напад□-2.4 брзина на напад",
  "item.minecraft.wooden_shovel": "дрвена лопата□□кога сте во главната рака:□+1.5 штета на напад□-3 брзина на напад",
  "item.minecraft.wooden_pickaxe": "дрвен копач□□кога сте во главната рака:□+1 штета на напад□-2.8 брзина на напад",
  "item.minecraft.wooden_axe": "дрвена секира□□кога сте во главната рака:□+6 штета на напад□-3.2 брзина на напад",
  "item.minecraft.stone_sword": "камен меч□□кога сте во главната рака:□+4 штета на напад□-2.4 брзина на напад",
  "item.minecraft.stone_shovel": "камена лопата□□кога сте во главната рака:□+2.5 штета на напад□-3 брзина на напад",
  "item.minecraft.stone_pickaxe": "камен копач□□кога сте во главната рака:□+2 штета на напад□-2.8 брзина на напад",
  "item.minecraft.stone_axe": "камена секира□□кога сте во главната рака:□+8 штета на напад□-3.2 брзина на напад",
  "item.minecraft.diamond_sword": "дијамантски меч□□кога сте во главната рака:□+6 штета на напад□-2.4 брзина на напад",
  "item.minecraft.diamond_shovel": "дијамантска лопата□□кога сте во главната рака:□+4.5 штета на напад□-3 брзина на напад",
  "item.minecraft.diamond_pickaxe": "дијамантски копач□□кога сте во главната рака:□+4 штета на напад□-2.8 брзина на напад",
  "item.minecraft.diamond_axe": "дијамантска секира□□кога сте во главната рака:□+8 штета на напад□-3 брзина на напад",
  "item.minecraft.stick": "стап",
  "item.minecraft.bowl": "чинија",
  "item.minecraft.mushroom_stew": "чорба од печурки",
  "item.minecraft.golden_sword": "златен меч□□кога сте во главната рака:□+3 штета на напад□-2.4 брзина на напад",
  "item.minecraft.golden_shovel": "златна лопата□□кога сте во главната рака:□+1.5 штета на напад□-3 брзина на напад",
  "item.minecraft.golden_pickaxe": "златен копач□□кога сте во главната рака:□+1 штета на напад□-2.8 брзина на напад",
  "item.minecraft.golden_axe": "златна секира□□кога сте во главната рака:□+6 штета на напад□-3 брзина на напад",
  "item.minecraft.netherite_sword": "пеколитски меч□□кога сте во главната рака:□+7 штета на напад□-2.4 брзина на напад",
  "item.minecraft.netherite_shovel": "пеколитска лопатка□□кога сте во главната рака:□+5.5 штета на напад□-3 брзина на напад",
  "item.minecraft.netherite_pickaxe": "пеколитски копач□□кога сте во главната рака:□+5 штета на напад□-2.8 брзина на напад",
  "item.minecraft.netherite_axe": "пеколитски секира□□кога сте во главната рака:□+9 штета на напад□-3 брзина на напад",
  "item.minecraft.string": "конец",
  "item.minecraft.feather": "пердув",
  "item.minecraft.gunpowder": "барут",
  "item.minecraft.wooden_hoe": "дрвена мотика□□кога сте во главната рака:□-3 брзина на напад",
  "item.minecraft.stone_hoe": "камена мотика□□кога сте во главната рака:□-2 брзина на напад",
  "item.minecraft.iron_hoe": "железна мотика□□кога сте во главната рака:□-1 брзина на напад",
  "item.minecraft.diamond_hoe": "дијамантска мотика□□кога сте во главната рака:",
  "item.minecraft.golden_hoe": "златна мотика□□кога сте во главната рака:□-3 брзина на напад",
  "item.minecraft.netherite_hoe": "пеколитска мотика□□кога сте во главната рака:",
  "item.minecraft.wheat_seeds": "семе од пченица",
  "item.minecraft.wheat": "пченица",
  "item.minecraft.bread": "леб",
  "item.minecraft.leather_helmet": "кожна капа□□кога е на главата:□+1 оклоп",
  "item.minecraft.leather_chestplate": "кожна туника□□кога е на тело:□+3 оклоп",
  "item.minecraft.leather_leggings": "кожни панталони□□кога сте на нозе:□+2 оклоп",
  "item.minecraft.leather_boots": "кожни чизми□□кога сте на стапалата:□+1 оклоп",
  "item.minecraft.chainmail_helmet": "верижен шлем□□кога е на главата:□+2 оклоп",
  "item.minecraft.chainmail_chestplate": "верижен оклоп□□кога е на тело:□+5 оклоп",
  "item.minecraft.chainmail_leggings": "верижни панталони□□кога сте на нозе:□+4 оклоп",
  "item.minecraft.chainmail_boots": "верижни чизми□□кога сте на стапалата:□+1 оклоп",
  "item.minecraft.iron_helmet": "железен шлем□□кога е на главата:□+2 оклоп",
  "item.minecraft.iron_chestplate": "железен оклоп□□кога е на тело:□+6 оклоп",
  "item.minecraft.iron_leggings": "железни панталони□□кога сте на нозе:□+5 оклоп",
  "item.minecraft.iron_boots": "железни чизми□□кога сте на стапалата:□+2 оклоп",
  "item.minecraft.diamond_helmet": "дијамантски шлем□□кога е на главата:□+3 оклоп□+2 издржливост на оклоп",
  "item.minecraft.diamond_chestplate": "дијамантски оклоп□□кога е на тело:□+8 оклоп□+2 издржливост на оклоп",
  "item.minecraft.diamond_leggings": "дијамантски панталони□□кога сте на нозе:□+6 оклоп□+2 издржливост на оклоп",
  "item.minecraft.diamond_boots": "дијамантски чизми□□кога сте на стапалата:□+3 оклоп□+2 издржливост на оклоп",
  "item.minecraft.golden_helmet": "златен шлем□□кога е на главата:□+2 оклоп",
  "item.minecraft.golden_chestplate": "златен оклоп□□кога е на тело:□+5 оклоп",
  "item.minecraft.golden_leggings": "златни панталони□□кога сте на нозе:□+3 оклоп",
  "item.minecraft.golden_boots": "златни чизми□□кога сте на стапалата:□+1 оклоп",
  "item.minecraft.netherite_helmet": "пеколитски шлем□□кога е на главата:□+3 оклоп□+3 издржливост на оклоп□+1 отпорност на одбивање",
  "item.minecraft.netherite_chestplate": "пеколитска мајца□□кога е на тело:□+8 оклоп□+3 издржливост на оклоп□+1 отпорност на одбивање",
  "item.minecraft.netherite_leggings": "пеколитски панталони□□кога сте на нозе:□+6 оклоп□+3 издржливост на оклоп□+1 отпорност на одбивање",
  "item.minecraft.netherite_boots": "пеколитски чизми□□кога сте на стапалата:□+3 оклоп□+3 издржливост на оклоп□+1 отпорност на одбивање",
  "item.minecraft.flint": "кремен",
  "item.minecraft.porkchop": "сурово свинско месо",
  "item.minecraft.cooked_porkchop": "печено свинско месо",
  "item.minecraft.painting": "слика",
  "item.minecraft.golden_apple": "златно јаболко",
  "item.minecraft.enchanted_golden_apple": "маѓепсано златно јаболко",
  "block.minecraft.oak_sign": "знак од даб",
  "block.minecraft.spruce_sign": "знак од смрека",
  "block.minecraft.birch_sign": "знак од бреза",
  "block.minecraft.jungle_sign": "знак од џунглиско дрво",
  "block.minecraft.acacia_sign": "знак од акација",
  "block.minecraft.dark_oak_sign": "знак од темен даб",
  "block.minecraft.crimson_sign": "црвен знак",
  "block.minecraft.warped_sign": "луд знак",
  "item.minecraft.bucket": "кофа",
  "item.minecraft.water_bucket": "кофа со вода",
  "item.minecraft.lava_bucket": "кофа со лава",
  "item.minecraft.minecart": "рударска количка",
  "item.minecraft.saddle": "седло",
  "item.minecraft.redstone": "редстоун прашина",
  "item.minecraft.snowball": "снежна топка",
  "item.minecraft.oak_boat": "чамец од даб",
  "item.minecraft.leather": "кожа",
  "item.minecraft.milk_bucket": "кофа со млеко",
  "item.minecraft.pufferfish_bucket": "кофа со риба-балон",
  "item.minecraft.salmon_bucket": "кофа со лосос",
  "item.minecraft.cod_bucket": "кофа со бакалар",
  "item.minecraft.tropical_fish_bucket": "кофа со тропска риба",
  "item.minecraft.brick": "цигла",
  "item.minecraft.clay_ball": "глинена топка",
  "block.minecraft.dried_kelp_block": "блок од исушена алга",
  "item.minecraft.paper": "хартија",
  "item.minecraft.book": "книга",
  "item.minecraft.slime_ball": "слузна топка",
  "item.minecraft.chest_minecart": "рударска количка со сандак",
  "item.minecraft.furnace_minecart": "рударска количка со печка",
  "item.minecraft.egg": "јајце",
  "item.minecraft.compass": "компас",
  "item.minecraft.fishing_rod": "трска за риболов",
  "item.minecraft.clock": "часовник",
  "item.minecraft.glowstone_dust": "прашина од светлосен камен",
  "item.minecraft.cod": "суров бакалар",
  "item.minecraft.salmon": "суров лосос",
  "item.minecraft.tropical_fish": "тропска риба",
  "item.minecraft.pufferfish": "риба-балон",
  "item.minecraft.cooked_cod": "печен бакалар",
  "item.minecraft.cooked_salmon": "печен лосос",
  "item.minecraft.ink_sac": "вреќичка со мастило",
  "item.minecraft.red_dye": "црвена фарба",
  "item.minecraft.green_dye": "зелена фарба",
  "item.minecraft.cocoa_beans": "какаови зрна",
  "item.minecraft.lapis_lazuli": "лазура",
  "item.minecraft.purple_dye": "виолетова фарба",
  "item.minecraft.cyan_dye": "сино-зелена фарба",
  "item.minecraft.light_gray_dye": "светлосива фарба",
  "item.minecraft.gray_dye": "сива фарба",
  "item.minecraft.pink_dye": "розова фарба",
  "item.minecraft.lime_dye": "зелена фарба",
  "item.minecraft.yellow_dye": "жолта фарба",
  "item.minecraft.light_blue_dye": "светлосина фарба",
  "item.minecraft.magenta_dye": "магента фарба",
  "item.minecraft.orange_dye": "портокалова фарба",
  "item.minecraft.bone_meal": "коскено брашно",
  "item.minecraft.blue_dye": "сина фарба",
  "item.minecraft.brown_dye": "кафеава фарба",
  "item.minecraft.black_dye": "црна фарба",
  "item.minecraft.white_dye": "бела фарба",
  "item.minecraft.bone": "коска",
  "item.minecraft.sugar": "шеќер",
  "block.minecraft.cake": "торта",
  "block.minecraft.white_bed": "бел кревет",
  "block.minecraft.orange_bed": "портокалов кревет",
  "block.minecraft.magenta_bed": "магента кревет",
  "block.minecraft.light_blue_bed": "светлосин кревет",
  "block.minecraft.yellow_bed": "жолт кревет",
  "block.minecraft.lime_bed": "жолто-зелен кревет",
  "block.minecraft.pink_bed": "розов кревет",
  "block.minecraft.gray_bed": "сив кревет",
  "block.minecraft.light_gray_bed": "светлосив кревет",
  "block.minecraft.cyan_bed": "сино-зелен кревет",
  "block.minecraft.purple_bed": "виолетов кревет",
  "block.minecraft.blue_bed": "син кревет",
  "block.minecraft.brown_bed": "кафеав кревет",
  "block.minecraft.green_bed": "зелен кревет",
  "block.minecraft.red_bed": "црвен кревет",
  "block.minecraft.black_bed": "црн кревет",
  "item.minecraft.cookie": "колаче",
  "item.minecraft.filled_map": "карта□#0",
  "item.minecraft.shears": "ножици",
  "item.minecraft.melon_slice": "парче лубеница",
  "item.minecraft.dried_kelp": "исушена алга",
  "item.minecraft.pumpkin_seeds": "семки од тиква",
  "item.minecraft.melon_seeds": "семки од лубеница",
  "item.minecraft.beef": "сурово говедско месо",
  "item.minecraft.cooked_beef": "бифтек",
  "item.minecraft.chicken": "сурова кокошка",
  "item.minecraft.cooked_chicken": "печена кокошка",
  "item.minecraft.rotten_flesh": "скапано месо",
  "item.minecraft.ender_pearl": "ендер бисер",
  "item.minecraft.blaze_rod": "пламена прачка",
  "item.minecraft.ghast_tear": "солза од гаст",
  "item.minecraft.gold_nugget": "златна грутка",
  "item.minecraft.nether_wart": "недер лишај",
  "item.minecraft.potion": "несоздавачка напивка□без ефекти",
  "item.minecraft.glass_bottle": "стаклено шише",
  "item.minecraft.spider_eye": "око од пајак",
  "item.minecraft.fermented_spider_eye": "ферментирано око од пајак",
  "item.minecraft.blaze_powder": "пламен прав",
  "item.minecraft.magma_cream": "магма крем",
  "block.minecraft.brewing_stand": "штанд за напивки",
  "block.minecraft.cauldron": "котел",
  "item.minecraft.ender_eye": "ендер око",
  "item.minecraft.glistering_melon_slice": "сјајно парче од лубеница",
  "item.minecraft.bat_spawn_egg": "јајце за создавање лилјак",
  "item.minecraft.bee_spawn_egg": "јајце за создавање пчела",
  "item.minecraft.blaze_spawn_egg": "јајце за создавање пламен",
  "item.minecraft.cat_spawn_egg": "јајце за создавање мачка",
  "item.minecraft.cave_spider_spawn_egg": "јајце за создавање пештерски пајак",
  "item.minecraft.chicken_spawn_egg": "јајце за создавање кокошка",
  "item.minecraft.cod_spawn_egg": "јајце за создавање бакалар",
  "item.minecraft.cow_spawn_egg": "јајце за создавање крава",
  "item.minecraft.creeper_spawn_egg": "јајце за создавање крипер",
  "item.minecraft.dolphin_spawn_egg": "јајце за создавање делфин",
  "item.minecraft.donkey_spawn_egg": "јајце за создавање магаре",
  "item.minecraft.drowned_spawn_egg": "јајце за создавање удавен",
  "item.minecraft.elder_guardian_spawn_egg": "јајце за создавање чувар старешина",
  "item.minecraft.enderman_spawn_egg": "јајце за создавање ендермен",
  "item.minecraft.endermite_spawn_egg": "јајце за создавање ендермит",
  "item.minecraft.evoker_spawn_egg": "јајце за создавање повикувач",
  "item.minecraft.fox_spawn_egg": "јајце за создавање лисица",
  "item.minecraft.ghast_spawn_egg": "јајце за создавање гаст",
  "item.minecraft.guardian_spawn_egg": "јајце за создавање чувар",
  "item.minecraft.hoglin_spawn_egg": "јајце за создавање пеколска свиња",
  "item.minecraft.horse_spawn_egg": "јајце за создавање коњ",
  "item.minecraft.husk_spawn_egg": "јајце за создавање пустинско зомби",
  "item.minecraft.llama_spawn_egg": "јајце за создавање лама",
  "item.minecraft.magma_cube_spawn_egg": "јајце за создавање магма коцка",
  "item.minecraft.mooshroom_spawn_egg": "јајце за создавање муушрум",
  "item.minecraft.mule_spawn_egg": "јајце за создавање муле",
  "item.minecraft.ocelot_spawn_egg": "јајце за создавање оцелот",
  "item.minecraft.panda_spawn_egg": "јајце за создавање панда",
  "item.minecraft.parrot_spawn_egg": "јајце за создавање папагал",
  "item.minecraft.phantom_spawn_egg": "јајце за создавање фантом",
  "item.minecraft.pig_spawn_egg": "јајце за создавање прасе",
  "item.minecraft.piglin_spawn_egg": "јајце за создавање свински човек",
  "item.minecraft.pillager_spawn_egg": "јајце за создавање разбојник",
  "item.minecraft.polar_bear_spawn_egg": "јајце за создавање поларна мечка",
  "item.minecraft.pufferfish_spawn_egg": "јајце за создавање риба-балон",
  "item.minecraft.rabbit_spawn_egg": "јајце за создавање зајак",
  "item.minecraft.ravager_spawn_egg": "јајце за создавање опустошител",
  "item.minecraft.salmon_spawn_egg": "јајце за создавање лосос",
  "item.minecraft.sheep_spawn_egg": "јајце за создавање овца",
  "item.minecraft.shulker_spawn_egg": "јајце за создавање шулкер",
  "item.minecraft.silverfish_spawn_egg": "јајце за создавање сребрена риба",
  "item.minecraft.skeleton_spawn_egg": "јајце за создавање скелет",
  "item.minecraft.skeleton_horse_spawn_egg": "јајце за создавање скелетен коњ",
  "item.minecraft.slime_spawn_egg": "јајце за создавање слуз",
  "item.minecraft.spider_spawn_egg": "јајце за создавање пајак",
  "item.minecraft.squid_spawn_egg": "јајце за создавање лигња",
  "item.minecraft.stray_spawn_egg": "јајце за создавање скитник",
  "item.minecraft.strider_spawn_egg": "јајце за создавање чекорец",
  "item.minecraft.trader_llama_spawn_egg": "јајце за создавање лама на трговец",
  "item.minecraft.tropical_fish_spawn_egg": "јајце за создавање тропска риба",
  "item.minecraft.turtle_spawn_egg": "јајце за создавање желка",
  "item.minecraft.vex_spawn_egg": "јајце за создавање напаст",
  "item.minecraft.villager_spawn_egg": "јајце за создавање селанец",
  "item.minecraft.vindicator_spawn_egg": "јајце за создавање бранител",
  "item.minecraft.wandering_trader_spawn_egg": "јајце за создавање трговец-скитник",
  "item.minecraft.witch_spawn_egg": "јајце за создавање вештерка",
  "item.minecraft.wither_skeleton_spawn_egg": "јајце за создавање видер скелет",
  "item.minecraft.wolf_spawn_egg": "јајце за создавање волк",
  "item.minecraft.zoglin_spawn_egg": "јајце за создавање зомби пеколска свиња",
  "item.minecraft.zombie_spawn_egg": "јајце за создавање зомби",
  "item.minecraft.zombie_horse_spawn_egg": "јајце за создавање зомби коњ",
  "item.minecraft.zombie_villager_spawn_egg": "јајце за создавање на зомби-селанец",
  "item.minecraft.zombified_piglin_spawn_egg": "јајце за создавање зомбиран свински човек",
  "item.minecraft.experience_bottle": "волшебно шише",
  "item.minecraft.fire_charge": "огнена топка",
  "item.minecraft.writable_book": "книга и перо",
  "item.minecraft.written_book": "напишана книга",
  "item.minecraft.emerald": "смарагд",
  "item.minecraft.item_frame": "рамка",
  "block.minecraft.flower_pot": "саксија",
  "item.minecraft.carrot": "морков",
  "item.minecraft.potato": "компир",
  "item.minecraft.baked_potato": "печен компир",
  "item.minecraft.poisonous_potato": "отворен компир",
  "item.minecraft.map": "празна карта",
  "item.minecraft.golden_carrot": "златен морков",
  "block.minecraft.skeleton_skull": "череп од скелет",
  "block.minecraft.wither_skeleton_skull": "череп од видер скелет",
  "block.minecraft.player_head": "глава од играч",
  "block.minecraft.zombie_head": "глава од зомби",
  "block.minecraft.creeper_head": "глава од крипер",
  "block.minecraft.dragon_head": "глава од змеј",
  "item.minecraft.carrot_on_a_stick": "морков на стап",
  "item.minecraft.warped_fungus_on_a_stick": "луда печурка на стап",
  "item.minecraft.nether_star": "недер ѕвезда",
  "item.minecraft.pumpkin_pie": "пита од тиква",
  "item.minecraft.firework_rocket": "огнометна ракета",
  "item.minecraft.firework_star": "огнометна ѕвезда",
  "item.minecraft.enchanted_book": "волшебна книга",
  "item.minecraft.nether_brick": "недер цигла",
  "item.minecraft.quartz": "недер кварц",
  "item.minecraft.tnt_minecart": "рударска количка со тнт",
  "item.minecraft.hopper_minecart": "рударска количка со собирач",
  "item.minecraft.prismarine_shard": "призмаринска острица",
  "item.minecraft.prismarine_crystals": "призмарински кристал",
  "item.minecraft.rabbit": "суров зајак",
  "item.minecraft.cooked_rabbit": "печен зајак",
  "item.minecraft.rabbit_stew": "чорба од зајак",
  "item.minecraft.rabbit_foot": "зајачка нога",
  "item.minecraft.rabbit_hide": "зајачка кожа",
  "item.minecraft.armor_stand": "држач за оклоп",
  "item.minecraft.iron_horse_armor": "железен коњски оклоп",
  "item.minecraft.golden_horse_armor": "златен коњски оклоп",
  "item.minecraft.diamond_horse_armor": "дијамантски коњски оклоп",
  "item.minecraft.leather_horse_armor": "кожен коњски оклоп",
  "item.minecraft.lead": "ортома",
  "item.minecraft.name_tag": "ознака за име",
  "item.minecraft.command_block_minecart": "рударска количка со команден блок",
  "item.minecraft.mutton": "сурово овчо месо",
  "item.minecraft.cooked_mutton": "печено овчо месо",
  "block.minecraft.white_banner": "бел банер",
  "block.minecraft.orange_banner": "портокалов банер",
  "block.minecraft.magenta_banner": "магента банер",
  "block.minecraft.light_blue_banner": "светлосин банер",
  "block.minecraft.yellow_banner": "жолт банер",
  "block.minecraft.lime_banner": "жолто-зелен банер",
  "block.minecraft.pink_banner": "розов банер",
  "block.minecraft.gray_banner": "сив банер",
  "block.minecraft.light_gray_banner": "светлосив банер",
  "block.minecraft.cyan_banner": "сино-зелен банер",
  "block.minecraft.purple_banner": "виолетов банер",
  "block.minecraft.blue_banner": "син банер",
  "block.minecraft.brown_banner": "кафеав банер",
  "block.minecraft.green_banner": "зелен банер",
  "block.minecraft.red_banner": "црвен банер",
  "block.minecraft.black_banner": "црн банер",
  "item.minecraft.end_crystal": "енд кристал",
  "item.minecraft.chorus_fruit": "хорус овошје",
  "item.minecraft.popped_chorus_fruit": "пукнато хорус овошје",
  "item.minecraft.beetroot": "цвекло",
  "item.minecraft.beetroot_seeds": "семе од цвекло",
  "item.minecraft.beetroot_soup": "супа од цвекло",
  "item.minecraft.dragon_breath": "змејски здив",
  "item.minecraft.splash_potion": "несоздавачка распрскувачка напивка□без ефекти",
  "item.minecraft.spectral_arrow": "спектрална стрела",
  "item.minecraft.tipped_arrow": "несоздавачка засилена стрела□без ефекти",
  "item.minecraft.lingering_potion": "несоздавачка лебдечка напивка□без ефекти",
  "item.minecraft.shield": "штит",
  "item.minecraft.elytra": "крила",
  "item.minecraft.spruce_boat": "чамец од смрека",
  "item.minecraft.birch_boat": "чамец од бреза",
  "item.minecraft.jungle_boat": "чамец од џунглиско дрво",
  "item.minecraft.acacia_boat": "чамец од акација",
  "item.minecraft.dark_oak_boat": "чамец од темен даб",
  "item.minecraft.totem_of_undying": "тотем на бесмртноста",
  "item.minecraft.shulker_shell": "шулкер школка",
  "item.minecraft.iron_nugget": "железна грутка",
  "item.minecraft.knowledge_book": "книга на знаење",
  "item.minecraft.debug_stick": "стап за откривање грешки",
  "item.minecraft.music_disc_13": "музички диск□c418 - 13",
  "item.minecraft.music_disc_cat": "музички диск□c418 - cat",
  "item.minecraft.music_disc_blocks": "музички диск□c418 - blocks",
  "item.minecraft.music_disc_chirp": "музички диск□c418 - chirp",
  "item.minecraft.music_disc_far": "музички диск□c418 - far",
  "item.minecraft.music_disc_mall": "музички диск□c418 - mall",
  "item.minecraft.music_disc_mellohi": "музички диск□c418 - mellohi",
  "item.minecraft.music_disc_stal": "музички диск□c418 - stal",
  "item.minecraft.music_disc_strad": "музички диск□c418 - strad",
  "item.minecraft.music_disc_ward": "музички диск□c418 - ward",
  "item.minecraft.music_disc_11": "музички диск□c418 - 11",
  "item.minecraft.music_disc_wait": "музички диск□c418 - wait",
  "item.minecraft.music_disc_pigstep": "музички диск□лена раин - pigstep",
  "item.minecraft.trident": "трозабец□□кога сте во главната рака:□+8 штета на напад□-2.9 брзина на напад",
  "item.minecraft.phantom_membrane": "фантомска мембрана",
  "item.minecraft.nautilus_shell": "наутилус школка",
  "item.minecraft.heart_of_the_sea": "срцето на морето",
  "item.minecraft.crossbow": "самострел",
  "item.minecraft.suspicious_stew": "сомнителна чорба",
  "block.minecraft.loom": "разбој",
  "item.minecraft.flower_banner_pattern": "шема за банер□фигура на цвет",
  "item.minecraft.creeper_banner_pattern": "шема за банер□фигура на крипер",
  "item.minecraft.skull_banner_pattern": "шема за банер□фигура на череп",
  "item.minecraft.mojang_banner_pattern": "шема за банер□нешто",
  "item.minecraft.globe_banner_pattern": "шема за банер□глобус",
  "item.minecraft.piglin_banner_pattern": "шема за банер□муцка",
  "block.minecraft.composter": "компостер",
  "block.minecraft.barrel": "буре",
  "block.minecraft.smoker": "пушач",
  "block.minecraft.blast_furnace": "висока печка",
  "block.minecraft.cartography_table": "картографска маса",
  "block.minecraft.fletching_table": "маса за изработка на стрели",
  "block.minecraft.grindstone": "камен за острење",
  "block.minecraft.lectern": "наслон за читање",
  "block.minecraft.smithing_table": "маса за ковање",
  "block.minecraft.stonecutter": "каменорезец",
  "block.minecraft.bell": "ѕвонче",
  "block.minecraft.lantern": "фенер",
  "block.minecraft.soul_lantern": "душни фенер",
  "item.minecraft.sweet_berries": "слатки бобинки",
  "block.minecraft.campfire": "логорски оган",
  "block.minecraft.soul_campfire": "душни логорски огин",
  "block.minecraft.shroomlight": "печурко светло",
  "item.minecraft.honeycomb": "саќе",
  "block.minecraft.bee_nest": "гнездо на пчели",
  "block.minecraft.beehive": "пчеларник",
  "item.minecraft.honey_bottle": "шише со мед",
  "block.minecraft.honey_block": "меден блок",
  "block.minecraft.honeycomb_block": "саќена коцка",
  "block.minecraft.lodestone": "магнетен камен",
  "block.minecraft.netherite_block": "коцка од пеколит",
  "block.minecraft.ancient_debris": "древни остаци",
  "block.minecraft.target": "мета",
  "block.minecraft.crying_obsidian": "плачлив обцидиан",
  "block.minecraft.blackstone": "црн камен",
  "block.minecraft.blackstone_slab": "плочка од црн камен",
  "block.minecraft.blackstone_stairs": "скали од црн камен",
  "block.minecraft.gilded_blackstone": "златен црн камен",
  "block.minecraft.polished_blackstone": "размазен црн камен",
  "block.minecraft.polished_blackstone_slab": "плочка од размазен црн камен",
  "block.minecraft.polished_blackstone_stairs": "скали од размазен црн камен",
  "block.minecraft.chiseled_polished_blackstone": "изработен размазен црн камен",
  "block.minecraft.polished_blackstone_bricks": "размазени цигли од црн камен",
  "block.minecraft.polished_blackstone_brick_slab": "плочка од размазени цигли од црн камен",
  "block.minecraft.polished_blackstone_brick_stairs": "скали од размазени цигли од црн камен",
  "block.minecraft.cracked_polished_blackstone_bricks": "пукнати размазени цигли од црн камен",
  "block.minecraft.respawn_anchor": "преродно сидро",
}
export const mk_mk = items; 
